import { makeStyles } from '@material-ui/core';
import { colors } from '../../constants.js/colors';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#f5f5f5',
        minHeight: '100vh',
        fontFamily: 'Inter, sans-serif',
    },
    appBar: {
        backgroundColor: 'white',
        color: '#173300',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        paddingTop: theme.spacing(3),
        zIndex: 1,
    },
    lowerAppBar: {
        backgroundColor: 'white',
        color: '#173300',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        zIndex: 1,
        paddingTop: theme.spacing(6),
    },
    toolbar: {
        justifyContent: 'space-between',
    },
    title: {
        fontWeight: 600,
        fontSize: '20px',
    },
    headerButtons: {
        display: 'flex',
        gap: theme.spacing(1),
    },
    iconButton: {
        border: '1px solid #173300',
        color: '#173300',
        width: '40px',
        height: '40px',
    },
    downloadButton: {
        border: '1px solid #173300',
        color: '#173300',
        borderRadius: '20px',
        padding: '6px 12px',
        textTransform: 'none',
        fontSize: '14px',
    },
    mainContent: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(10),
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    orderCard: {
        borderRadius: '16px',
        marginBottom: theme.spacing(2),
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: theme.spacing(1),
    },
    orderNumber: {
        fontWeight: 600,
        color: '#173300',
    },
    orderDate: {
        color: '#4A4A4A',
        fontSize: '14px',
        marginLeft: theme.spacing(1),
    },
    orderAmount: {
        fontWeight: 700,
        fontSize: '18px',
        color: '#173300',
        marginTop: theme.spacing(0.5),
    },
    orderDetails: {
        fontSize: '14px',
        color: '#4A4A4A',
        marginBottom: theme.spacing(1),
    },
    customerInfo: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '14px',
        color: '#4A4A4A',
        marginBottom: theme.spacing(2),
    },
    customerIcon: {
        marginRight: theme.spacing(0.5),
        color: '#173300',
        fontSize: '16px',
    },
    cardActions: {
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: '1px solid #f0f0f0',
        paddingTop: theme.spacing(2),
        gap: theme.spacing(1),
    },
    actionButton: {
        borderRadius: '20px',
        textTransform: 'none',
        fontSize: '14px',
        padding: '6px 12px',
        minWidth: 'auto',
    },
    viewButton: {
        border: '1px solid #173300',
        color: '#173300',
    },
    whatsappButton: {
        backgroundColor: '#25D366',
        color: 'white',
        '&:hover': {
            backgroundColor: '#20b358',
        },
    },
    statusButton: {
        border: '1px solid #173300',
        color: '#173300',
    },
    statusChip: {
        fontSize: '12px',
        fontWeight: 500,
        cursor: 'pointer',
    },
    pendingChip: {
        border: '1px solid #4A4A4A',
        color: '#4A4A4A',
        backgroundColor: 'transparent',
    },
    preparingChip: {
        backgroundColor: '#1A1A1A',
        color: '#F5F5F5',
    },
    shippedChip: {
        backgroundColor: '#9EE870',
        color: 'white',
    },
    returnedChip: {
        backgroundColor: '#4A4A4A',
        color: 'white',
    },
    programmedChip: {
        backgroundColor: '#FFA500',
        color: 'white',
    },
    cancelledChip: {
        color: '#ffffff',
        backgroundColor: '#f44336',
    },
    dialogTitle: {
        borderBottom: '1px solid #f0f0f0',
        padding: '4px 8px',
    },
    statusOption: {
        padding: theme.spacing(1),
        gap: '8px',
        borderRadius: '8px',
        '&:hover': {
            backgroundColor: '#f5f5f5',
        },
    },
    statusOptionContent: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    successAlert: {
        backgroundColor: 'white',
        color: '#173300',
        borderRadius: '8px',
    },
    errorAlert: {
        backgroundColor: 'white',
        color: '#f44336',
        borderRadius: '8px',
    },
    toastActions: {
        display: 'flex',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    whatsappToastButton: {
        backgroundColor: '#25D366',
        color: 'white',
        borderRadius: '20px',
        fontSize: '12px',
        padding: '4px 16px',
        textTransform: 'none',
    },
    noToastButton: {
        border: '1px solid #4A4A4A',
        color: '#4A4A4A',
        borderRadius: '20px',
        fontSize: '12px',
        padding: '4px 16px',
        textTransform: 'none',
    },
    dialog: {
        '& .MuiDialog-paper': {
            margin: 0,
            maxHeight: '100vh',
            height: '100vh',
            maxWidth: '100vw',
            width: '100vw',
            borderRadius: 0,
        },
    },
    dialogTitle: {
        padding: theme.spacing(2),
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        fontSize: '20px',
        fontWeight: 600,
        color: '#173300',
    },
    closeButton: {
        padding: theme.spacing(1),
        '&:hover': {
            backgroundColor: '#f3f4f6',
        },
    },
    dialogContent: {
        flex: 1,
        overflow: 'auto',
        padding: theme.spacing(2),
        paddingBottom: theme.spacing(12),
    },
    filterCard: {
        marginBottom: theme.spacing(1.5),
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        boxShadow: 'none',
    },
    cardContent: {
        padding: theme.spacing(2),
        '&:last-child': {
            paddingBottom: theme.spacing(2),
        },
    },
    cardTitle: {
        fontSize: '16px',
        fontWeight: 500,
        color: '#173300',
        marginBottom: theme.spacing(1.5),
    },
    dateChipsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    dateChip: {
        height: 44,
        minWidth: 'auto',
        padding: '0 12px',
        border: '1px solid #d1d5db',
        color: '#374151',
        backgroundColor: 'white',
        fontSize: '14px',
        '&:hover': {
            borderColor: '#173300',
            color: '#173300',
        },
        '&.selected': {
            backgroundColor: '#173300',
            color: 'white',
            borderColor: '#173300',
        },
        '&:focus': {
            backgroundColor: '#173300 !important',
        },
    },
    dateInputsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
    textField: {
        '& .MuiOutlinedInput-root': {
            minHeight: 44,
            '& fieldset': {
                borderColor: '#d1d5db',
            },
            '&:hover fieldset': {
                borderColor: '#173300',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#173300',
                borderWidth: 2,
            },
        },
        '& .MuiInputLabel-outlined': {
            fontSize: '14px',
            fontWeight: 500,
            color: '#374151',
        },
    },
    checkboxContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
    checkboxLabel: {
        minHeight: 44,
        alignItems: 'center',
        margin: 0,
        '& .MuiCheckbox-root': {
            color: '#d1d5db',
            '&.Mui-checked': {
                color: '#173300',
            },
        },
        '& .MuiFormControlLabel-label': {
            color: '#374151',
            fontSize: '14px',
        },
    },
    selectField: {
        '& .MuiOutlinedInput-root': {
            minHeight: 44,
            backgroundColor: 'white',
            '& fieldset': {
                borderColor: '#d1d5db',
            },
            '&:hover fieldset': {
                borderColor: '#173300',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#173300',
                borderWidth: 2,
            },
        },
    },
    dialogActions: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        borderTop: '1px solid #e5e7eb',
        padding: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(1.5),
    },
    clearButton: {
        flex: 1,
        height: 48,
        border: '2px solid #73EDB8',
        color: '#73EDB8',
        borderRadius: '8px',
        fontWeight: 500,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#73EDB8',
            color: 'white',
        },
    },
    applyButton: {
        flex: 1,
        height: 48,
        backgroundColor: '#9EE870',
        color: 'white',
        borderRadius: '8px',
        fontWeight: 500,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#8dd85f',
        },
    },
    activeFiltersContainer: {
        position: 'fixed',
        top: 64,
        left: 0,
        right: 0,
        backgroundColor: colors.white,
        borderBottom: '1px solid #e5e7eb',
        padding: theme.spacing(2),
        zIndex: 1300,
    },
    activeFiltersChips: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
    },
    activeFilterChip: {
        border: '1px solid #173300',
        color: '#173300',
        backgroundColor: colors.white,
        '& .MuiChip-deleteIcon': {
            color: '#173300',
            '&:hover': {
                color: '#dc2626',
            },
        },
    },
    deleteButton: {
        backgroundColor: colors.error.main,
        color: colors.white,
        '&:hover': {
            backgroundColor: colors.error.dark,
        },
    },
}));

export default useStyles;
